export default {
	personalCenter: {
		vip_member: 'สมาชิก VIP',
		vip: {
			level_label: 'ระดับ VIP{level}', next_level: 'ระดับถัดไป: VIP{level}',
			points_summary: 'สะสมแล้ว {current} คะแนน ต้องการอีก {remaining} คะแนนเพื่อถึง VIP{level}',
			level_rewards: 'รางวัลระดับ', reward_title: 'รางวัล VIP{level}', exclusive_rewards: 'รางวัลพิเศษ', promotion_reward: 'รางวัลเลื่อนระดับ VIP{level}',
			previous_level: 'ระดับก่อนหน้า', next_level_button: 'ระดับถัดไป',
			dragon_key: 'กุญแจวิญญาณมังกร ×{count}', battle_shard: 'ชิ้นส่วนตราสงคราม ×{count}', forge_crystal: 'ผลึกหลอม ×{count}',
			unlocked: 'ถึง VIP{level} แล้ว รับรางวัลได้ทันที', locked: 'ยังไม่ถึง VIP{level}',
			claim: 'รับรางวัล', claiming: 'กำลังรับ...', claimed: 'รับแล้ว', claim_success: 'รับรางวัล VIP{level} แล้ว', claim_failed: 'รับรางวัลไม่สำเร็จ โปรดลองอีกครั้งภายหลัง',
			points_label: 'คะแนน', go_redeem: 'ไปแลก',
			experience_summary: 'EXP สะสม {current}; ต้องการอีก {remaining} EXP เพื่อถึง VIP{level}',
			max_level: 'ยินดีด้วย คุณถึงระดับสูงสุดแล้ว', current_experience: 'EXP ปัจจุบัน: {current}'
		},
		title: 'ศูนย์ส่วนบุคคล', my_exchange: 'ประวัติแลกของฉัน', my_points: 'คะแนนของฉัน', lottery_records: 'ประวัติการสุ่ม', recharge_records: 'ประวัติเติมเงิน',
		redeem_gift: 'แลกรับของขวัญ', redeem_description: 'กรอกรหัสแลกเพื่อส่งรางวัลไปยังตัวละครที่เลือก', redeem_code: 'รหัสแลก', redeem_code_placeholder: 'กรอกรหัสแลก', redeeming: 'กำลังแลก...', redeem_now: 'แลกทันที', rebate_coupon: 'คูปองคืนเงิน {percent}%',
		points_details: 'รายละเอียดคะแนน', exchange_time: 'เวลาแลก', reward_content: 'รางวัล', status: 'สถานะ', time: 'เวลา', type: 'ประเภท', points_change: 'คะแนนเปลี่ยนแปลง', balance: 'ยอดคงเหลือ', lottery_time: 'เวลาสุ่ม', reward: 'รางวัล',
		order_id: 'หมายเลขคำสั่งซื้อ', payment_channel: 'ช่องทางชำระเงิน', amount: 'จำนวนเงิน', server: 'เซิร์ฟเวอร์', role: 'ตัวละคร', payment_time: 'เวลาชำระเงิน', copy: 'คัดลอก',
		loading: 'กำลังโหลด...', no_records: 'ไม่พบรายการที่ตรงกัน', no_content: 'ยังไม่มีข้อมูลที่จะแสดง', previous: 'ก่อนหน้า', next: 'ถัดไป', page_info: 'หน้า {current} / {total}',
		source_recharge_reward: 'รางวัลเติมเงิน', source_official_activity: 'กิจกรรมเว็บไซต์', source_item_exchange: 'แลกไอเทม',
		exchange_success: 'แลกสำเร็จ', exchange_failed: 'แลกไม่สำเร็จ', enter_redeem_code: 'กรุณากรอกรหัสแลก', exchange_retry: 'แลกไม่สำเร็จ โปรดลองอีกครั้งภายหลัง',
		copy_success: 'คัดลอกสำเร็จ', copy_failed: 'คัดลอกไม่สำเร็จ', lottery_load_failed: 'โหลดประวัติการสุ่มไม่สำเร็จ', lottery_load_retry: 'โหลดประวัติการสุ่มไม่สำเร็จ โปรดลองอีกครั้งภายหลัง',
		recharge_load_failed: 'โหลดประวัติเติมเงินไม่สำเร็จ', recharge_load_retry: 'โหลดประวัติเติมเงินไม่สำเร็จ โปรดลองอีกครั้งภายหลัง', points_load_failed: 'โหลดประวัติคะแนนไม่สำเร็จ', points_load_retry: 'โหลดประวัติคะแนนไม่สำเร็จ โปรดลองอีกครั้งภายหลัง',
		exchange_records_load_failed: 'โหลดประวัติการแลกไม่สำเร็จ', exchange_records_load_retry: 'โหลดประวัติการแลกไม่สำเร็จ โปรดลองอีกครั้งภายหลัง'
	},
	member_popup: {
		title: 'คะแนนสมาชิกเพิ่มขึ้นแล้ว!',
		message: 'การเติมเงินครั้งนี้ได้รับ {points} คะแนน ต้องการอีก {remaining} คะแนนเพื่อถึง VIP{nextLevel}',
		progress: 'คะแนนเติมเงินสะสม {current} / {target}',
		next: 'ต้องการอีก {remaining} คะแนนเพื่อถึง VIP{nextLevel}',
		suppress: 'ไม่ต้องแจ้งเตือนอีกภายใน 7 วัน',
		later: 'ไว้ภายหลัง',
		rewards: 'ไปรับรางวัล',
		close: 'ปิดการแจ้งเตือนสมาชิก'
	},
	member_level: {
		title: 'ระดับสมาชิก',
		points_progress: 'คะแนนเติมเงินสะสม',
		next_level: 'ต้องการอีกเพื่อขึ้น VIP{level}:',
		points_unit: 'คะแนน',
		view_rewards: 'ดูรางวัลระดับ'
	},
	login_button_text: 'เข้าสู่ระบบ',
	logining_button_text: 'เข้าสู่ระบบ',
	account_input_text: 'ป้อนอีเมลที่ผูกบัญชี',
	password_input_text: 'กรุณากรอกรหัสผ่าน',
	other_login_methods_text: 'วิธีเข้าสู่ระบบอื่น',
	top_up_center_text: 'ศูนย์เติมเงิน',
	benefit_text: 'สวัสดิการ',
	sign_in_text: 'เข้าสู่ระบบ',
	log_out_text: 'ออกจากระบบ',
	service_terms_text: 'ข้อกำหนดในการให้บริการ',
	privacy_policy_text: 'นโยบายความเป็นส่วนตัว',
	official_apk_download_text: 'ดาวน์โหลด APK อย่างเป็นทางการ',
	official_facebook_text: 'Facebook อย่างเป็นทางการ',
	recharge_instructions_text: 'คำแนะนำการเติมเงิน',
	rebate_countdown_title: 'โปรโมชั่นคืนเงินเปิดให้บริการ',
	rebate_countdown_label: 'นับถอยหลัง',
	rebate_countdown_days: 'วัน',
	rebate_countdown_hours: 'ชม.',
	rebate_countdown_minutes: 'นาที',
	rebate_countdown_seconds: 'วินาที',
	log_in_game_account_text: 'เข้าสู่ระบบบัญชีเกมของคุณ',
	sign_in_lowercase_text: 'เข้าสู่ระบบ',
	instructions_text: 'คำอธิบาย',
	confirm_text: 'ยืนยัน',
	cancel_text: 'ยกเลิก',
	switch_character_text: 'เปลี่ยนตัวละคร',
	copy_successful_text: 'คัดลอกสำเร็จ',
	claimed_text: 'กดรับแล้ว',
	claim_success_text: 'รับของรางวัลสำเร็จ',
	claim_text: 'กดรับ',
	claim_unmet_text: 'ไม่ผ่านเงื่อนไข',
	contact_customer_service_text: 'ติดต่อฝ่ายบริการลูกค้า',
	home_page_text: 'หน้าแรก',
	payment_successful_text: 'การชำระเงินสำเร็จ',
	purchase_confirm_text: 'ยืนยันการซื้อ',
	payment_channels_text: 'ช่องทางการชำระเงิน',
	payment_button_text: 'การชำระเงิน',
	original_price_text: 'ราคาปกติ',
	discounts_text: 'ส่วนลด',
	earn_points_text: 'รับคะแนน',
	rebates_text: 'ส่วนลดคืน',
	amount_text: 'ราคา',
	daily_rewards_text: 'รางวัลรายวัน',
	insufficient_points_text: 'คะแนนไม่เพียงพอ',
	insufficient_lottery_count_text: 'จำนวนครั้งในการจับรางวัลไม่เพียงพอ',
	network_error_retry_text: 'เกิดข้อผิดพลาดของเครือข่าย โปรดลองอีกครั้งภายหลัง',
	score_lottery_text: 'ลอตเตอรี่คะแนน',
	score_lottery_entrance_error: 'เกิดข้อผิดพลาดในการขอข้อมูลทางเข้าลอตเตอรี่คะแนน:',
	lottery_current_points_label: 'คะแนนปัจจุบัน:',
	lottery_points_recharge_tip: 'รับคะแนนได้จากการเติมเงิน',
	lottery_spin_label: 'หมุนวงล้อ',
	lottery_rule_button: 'รายละเอียดกติกา',
	lottery_rule_popup_title: 'กติกากิจกรรม',
	lottery_record_button: 'ดูประวัติรางวัล',
	lottery_record_title: 'ประวัติรางวัล',
	lottery_record_empty: 'ยังไม่มีประวัติ',
	lottery_record_time: 'เวลา',
	lottery_record_prize: 'รายละเอียดรางวัล',
	lottery_daily_limit: 'ถึงขีดจำกัดวันนี้แล้ว',
	lottery_remaining_count: 'จำนวนครั้งคงเหลือ {count}',
	lottery_draw_cost: '{cost} คะแนน/ครั้ง',
	lottery_init_data_error: 'เกิดข้อผิดพลาดในการขอข้อมูลลอตเตอรี่คะแนน:',
	points_text: 'ร้านค้าจุด',
	winning_award_text: "ขอแสดงความยินดีที่ได้รับรางวัล",
	receive_reward_tips_text: "ของรางวัลถูกส่งไปยังกล่องจดหมายของตัวละครของคุณแล้ว กรุณาเข้าสู่ระบบเพื่อรับของรางวัล!",
	hot_title_text: "HOT",
	limit_title_text: "LIMIT",
	limit_text: "Limit",
	sell_out_text: "ขายหมดแล้ว",
	copy_fail_text: "คัดลอกล้มเหลว",
	payment_type_text: "ช่องทางการชำระเงิน",
	order_id_text: "หมายเลขคำสั่งซื้อ",
	payment_time_text: "เวลาชำระเงิน",
	copy_text: "คัดลอก",
	amount_text: "จำนวนเงิน",
	game_server_text: "เซิร์ฟเวอร์",
	game_role_text: "ตัวละคร",
	orders_records_text: "ประวัติการเติมเงิน",
	no_data_text: 'ไม่มีข้อมูล',
	orders_tips_text: "ตามการตั้งค่าระบบ ข้อมูลประวัติการเติมเงินจะแสดงเฉพาะภายใน 30 วันที่ผ่านมา",
	pointsDescribeText: '',
	pointsBalanceText: '',
	points_period_daily: 'วันนี้',
	points_period_week: 'สัปดาห์นี้',
	points_period_month: 'เดือนนี้',
	points_period_lifetime: 'ตลอดชีพ',
	points_tag_mustBuy: 'ต้องซื้อ',
	points_tag_selected: 'คัดสรร',
	points_tag_discount: 'ส่วนลด',
	points_tag_perk: 'สิทธิพิเศษ',
	coupon: {
		discount_label: '返利券',
		title_html: '使用返利券購買後可額外獲得返利。',
		expired_text: '已失效',
		used_text: '已使用',
		countdown_prefix: '倒數',
		activity_button_text: 'Payback Coupon Draw'
	},
	pagination: {
		previous: "ก่อนหน้า",
		next: "ถัดไป",
		page_info: "หน้า {current} จาก {total}"
	},
	// Support
	support_my_questions: 'คำถามของฉัน',
	support_submit_issue: 'ส่งคำถาม',
	support_records_title: 'ประวัติปัญหาของฉัน',
	support_records_desc: 'ตรวจสอบความคืบหน้าและเพิ่มข้อมูลได้',
	support_refresh: 'รีเฟรช',
	support_tabs_label: 'แท็บฝ่ายสนับสนุน',
	support_load_more: 'โหลดเพิ่มเติม',
	support_user_id: 'ID ผู้ใช้',
	support_game: 'เกม',
	support_platform: 'แพลตฟอร์ม',
	support_back: 'กลับ',
	support_mark_solved: 'แก้ไขแล้ว',
	support_official_support: 'ฝ่ายสนับสนุนทางการ',
	support_image: 'รูปภาพ',
	support_reply_hint: 'ข้อมูลเพิ่มเติมของคุณจะถูกส่งถึงฝ่ายสนับสนุน',
	support_send: 'ส่ง',
	support_sending: 'กำลังส่ง...',
	support_player: 'ผู้เล่น',
	support_attachment_preview: 'ดูตัวอย่างไฟล์แนบ',
	support_remove_attachment: 'ลบไฟล์แนบ',
	support_attachment_fallback: 'ไฟล์แนบ',
	support_survey_title: 'แบบสำรวจ',
	support_survey_message: 'ปัญหาของคุณได้รับการแก้ไขแล้วหรือไม่?',
	support_survey_close: 'ปิด',
	support_submit_success: 'ส่งสำเร็จ',
	support_submit_fail: 'ส่งล้มเหลว',
	support_close_success: 'ปิดการสนทนาแล้ว',
	support_close_fail: 'ปิดไม่สำเร็จ',
	support_rate_title: 'กรุณาประเมินการให้บริการครั้งนี้',
	support_input_placeholder: 'กรุณาใส่เนื้อหา...',
	support_image_pick_error: 'ไม่สามารถรับเส้นทางรูปภาพ',
	support_send_fail: 'ส่งล้มเหลว',
	support_evaluate_success: 'ประเมินสำเร็จ',
	support_evaluate_fail: 'ประเมินล้มเหลว',
	support_status_unreplied: 'ยังไม่ได้ตอบ',
	support_status_replied: 'ตอบแล้ว',
	support_status_resolved: 'แก้ไขแล้ว',
	support_status_pending_review: 'รอการประเมิน',
	support_form_type_label: 'ประเภทปัญหา',
	support_form_type_placeholder: 'เลือกประเภทปัญหา',
	support_form_desc_label: 'รายละเอียดปัญหา',
	support_form_desc_placeholder: 'กรุณาอธิบายปัญหาโดยละเอียด...',
	support_form_upload_label: 'ไฟล์แนบ',
	support_form_upload_click: 'อัปโหลดไฟล์',
	support_form_upload_tips: '(รูปไม่เกิน 10MB, วิดีโอไม่เกิน 50MB, สูงสุด 5 ไฟล์)',
	support_form_submit: 'ส่ง',
	support_form_image_too_big: 'ขนาดรูปภาพต้องไม่เกิน 10MB',
	support_form_video_too_big: 'ขนาดวิดีโอต้องไม่เกิน 50MB',
	support_type_topup: 'ปัญหาการเติมเงิน',
	support_type_account: 'ปัญหาบัญชี',
	support_type_guide: 'แนวทางการเล่น',
	support_type_suggestion: 'ข้อเสนอแนะ',
	support_type_event: 'ปัญหากิจกรรม',
	support_type_report: 'รายงานการละเมิด',
	support_type_other: 'อื่น ๆ',
	support_type_topup_hint: 'เติมเงินไม่เข้า หรือยอดเงินผิด',
	support_type_account_hint: 'เข้าสู่ระบบ แบน หรือผูกบัญชี',
	support_type_guide_hint: 'การเล่น ภารกิจ ความคืบหน้า',
	support_type_suggestion_hint: 'ข้อเสนอแนะและความคิดเห็น',
	support_type_report_hint: 'โกง ด่าทอ หรือฝ่าฝืนกฎ',
	support_type_other_hint: 'ปัญหาอื่นที่ไม่ได้จัดหมวดหมู่',
	support_type_topup_code: 'Pay',
	support_type_account_code: 'Acc',
	support_type_guide_code: 'Tip',
	support_type_suggestion_code: 'Idea',
	support_type_report_code: 'Rpt',
	support_type_other_code: 'Etc',
	support_submitting: 'กำลังส่ง...',
	rebate_limited_text: '🔥 คืนเงิน {pct}% ช่วงเวลาจำกัด',
	rebate_percent_text: 'คืนเงิน {pct}%',
	coupon_booster_label: 'คูปองเพิ่มส่วนลดคืน',
	coupon_expires_after: 'หมดอายุใน {time}',
	coupon_threshold_shortfall: 'ซื้อเพิ่มอีก {amount} เพื่อใช้คูปอง',
	coupon_product_excluded: 'ไม่สามารถใช้กับสินค้านี้ได้',
	coupon_channel_restricted: 'ใช้ได้เฉพาะการชำระเงินผ่าน {channels}',
	coupon_unavailable_title: 'คูปองที่ใช้ไม่ได้',
	coupon_skip_text: 'ไม่ใช้คูปอง',
	coupon_count_unit: '',
	coupon_picker_title: 'เลือกคูปอง',
	coupon_entry_label: 'คูปอง',
	coupon_available_count: 'ใช้ได้ {count} ใบ',
	coupon_no_use_text: 'ไม่ใช้คูปอง',
	coupon_best_tag: 'ดีที่สุด',
	coupon_expired_text: 'หมดอายุแล้ว',
	close_text: 'ปิด',
	discount_coupon_label: 'คูปองส่วนลด',
	coupon_single_use_hint: 'ใช้คูปองได้หนึ่งใบต่อคำสั่งซื้อ',
	order_amount_text: 'ยอดสินค้า',
	discount_amount_text: 'ส่วนลดคูปอง',
	payable_amount_text: 'ยอดชำระ',
	coupon_extra_rebate_notice: 'เงินคืนเพิ่มเติม 50% จะส่งทางจดหมาย โปรดติดต่อฝ่ายบริการลูกค้าเพื่อลงทะเบียน',
	payment_recommended_text: 'วิธีชำระเงินแนะนำ',
	payment_enjoy_rebate: 'รับ {pct}% คืน',
	payment_order_rebate: 'เงินคืนรายการนี้ {amount}',
	payment_order_discount: 'ส่วนลดรายการนี้ {amount}',
	recommend_text: 'แนะนำ',
	payment_other_methods_text: 'วิธีชำระเงินอื่น',
	super_coupon_title: 'ซูเปอร์คูปองเวลาจำกัด',
	super_coupon_end_time: 'กิจกรรมสิ้นสุด:',
	super_coupon_previous_activity: 'กิจกรรมซูเปอร์คูปองก่อนหน้า',
	super_coupon_recommended: 'แนะนำ',
	super_coupon_view_details: 'ดูรายละเอียดชุดคูปอง',
	super_coupon_value_label: 'มูลค่าส่วนลดรวม',
	super_coupon_contents: 'รายการในชุดคูปอง',
	super_coupon_threshold: 'ซื้อครบ {amount}',
	super_coupon_discount: 'ลด {amount}',
	super_coupon_remaining: 'เหลือ {time}',
	super_coupon_purchased: 'ซื้อแล้ว',
	super_coupon_buy_now: 'ซื้อเลย',
	super_coupon_next_activity: 'กิจกรรมซูเปอร์คูปองถัดไป',
	super_coupon_switcher: 'สลับกิจกรรมซูเปอร์คูปอง',
	super_coupon_switch_to: 'ไปยังกิจกรรมซูเปอร์คูปองที่ {index}',
	super_coupon_details_title: 'รายละเอียดชุดซูเปอร์คูปอง',
	super_coupon_close_details: 'ปิดรายละเอียดชุดซูเปอร์คูปอง',
	super_coupon_empty: 'ขณะนี้ไม่มีคูปองส่วนลด',
	super_coupon_instructions: 'วิธีใช้',
	super_coupon_confirm: 'เข้าใจแล้ว',
	super_coupon_package_name: 'ชุดซูเปอร์คูปอง',
	super_coupon_get_coupons: 'รับคูปองส่วนลด {count} ใบทันทีเมื่อซื้อ',
	super_coupon_reward_multiple: 'คุ้มค่าประมาณ {multiple} เท่า',
	super_coupon_purchase_limit: 'จำกัด {count} ชุดต่อการซื้อหนึ่งครั้ง',
	super_coupon_purchase_interval: 'เว้นระยะการซื้อ {days} วัน',
	super_coupon_rule_separator: ', ',
	super_coupon_unknown_status: 'ไม่ทราบสถานะ',
	super_coupon_date_format: '{day}/{month}/{year} {time}',
	super_coupon_used: 'ใช้แล้ว',
	super_coupon_expired: 'หมดอายุแล้ว',
	super_coupon_unit_day: 'วัน',
	super_coupon_unit_days: 'วัน',
	super_coupon_unit_hour: 'ชั่วโมง',
	super_coupon_unit_hours: 'ชั่วโมง',
	super_coupon_unit_minute: 'นาที',
	super_coupon_unit_minutes: 'นาที',
	super_coupon_valid_for: 'ใช้ได้ภายใน {value} {unit}'
}
